// extracted by mini-css-extract-plugin
module.exports = {"scroll":"scroll-view_scroll__26H0r","touch":"scroll-view_touch___zLMt"};